import { useNavigate } from 'react-router-dom';
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useDispatch } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import { GoPlus } from 'react-icons/go';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { formatNumber, onChange } from '../../utils/functions';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import DeleteModal from '../../components/DeleteModal';
import { CUSTOMER_PATH, deleteCustomer, downloadCustomerExcelFile, downloadCustomerReceipt, downloadDetailedCustomerReceipt, getPageCustomers, toggleCustomerMark, uploadCustomerExcelFile } from '../../api/customerApi';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { pageModel } from '../../utils/model';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { MdPayments } from 'react-icons/md';
import { IoReceiptSharp } from 'react-icons/io5';
import CustomerReceipt from '../../components/customer/CustomerReceipt';

const CustomerListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [customerPage, setCustomerPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${CUSTOMER_PATH}`, false)
    const [searchParams, setSearchParams] = useState({
        id: "",
        code: "",
        name: "",
        showOnlyMarked: false
    })
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();
    const [isOpenReceiptModal, setIsOpenReceiptModal] = useState(false)
    const [receiptCustomer, setReceiptCustomer] = useState()

    useEffect(() => {
        loadCustomers({ size: 20, page: customerPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!customerPage.last) {
            loadCustomers({ ...searchParams, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching(searchParams)
    }, [searchParams])

    const loadCustomers = (params) => {
        !pendingApiCall &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteCustomer(deleteId)
            .then(res => {
                setIsOpen(false)
                setCustomerPage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== res.data.id) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const downloadExcelFile = () => {
        downloadCustomerExcelFile().then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'müşteriler.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    const onClickDownloadReceipt = (firstDate, lastDate) => {
        downloadCustomerReceipt(receiptCustomer.id, firstDate, lastDate)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Detaysız Ekstre - ${receiptCustomer.name}`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    const onClickDownloadDetailedReceipt = (firstDate, lastDate) => {
        downloadDetailedCustomerReceipt(receiptCustomer.id, firstDate, lastDate)
            .then(res => {
                const blob = new Blob([res.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Detaylı Ekstre - ${receiptCustomer.name}`;
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                toast.error('Dosya indirilirken hata oluştu!')
            })
    }

    const onClickToggleMark = (id) => {
        toggleCustomerMark(id)
            .then(res => {
                setCustomerPage(prev => ({ ...prev, content: prev.content.map(p => p.id === id ? res.data : p) }))
            }).catch(err => {

            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    MÜŞTERİLER
                </label>
            </div>
            <div className='flex justify-between items-center sticky top-0 bg-zinc-50'>
                <div className='flex gap-x-2 py-2 '>
                    <Button
                        text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Müşteri</label>}
                        variant='green'
                        onClick={() => nav('/customer/add')}
                    />
                    <label
                        className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                        htmlFor='excel-download'
                        onClick={downloadExcelFile}
                    >
                        <FaCloudDownloadAlt />
                        <span> Excel İndir</span>
                    </label>
                </div>

            </div>
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-1/12'>Müş. Kodu</th>
                        <th className='p-2 w-3/12'>Müşteri Adı</th>
                        <th className='p-2 w-1/12'>Kur</th>
                        {/* <th className='p-2 w-1/12'>Telefon</th> */}
                        <th className='p-2 w-2/12'>Borç</th>
                        <th className='p-2 w-2/12'>Alacak</th>
                        <th className='p-2 w-2/12'>Bakiye</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Müşteri kodu...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Müşteri adı...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td className='p-2'>
                            <div className='flex justify-end'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${searchParams.showOnlyMarked ? 'fill-red-700' : ''} w-5 h-5 cursor-pointer hover:fill-red-700 duration-150`} onClick={() => setSearchParams(prev => ({ ...prev, showOnlyMarked: !prev.showOnlyMarked }))} >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" />
                                </svg>
                            </div>

                        </td>
                    </tr>
                    {
                        customerPage.content.map((customer, index) => (
                            <tr key={index} className='border-b items-center text-sm hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {customer.id} </td>
                                <td className='p-2'>{customer.code} </td>
                                <td className='p-2'>{customer.name}</td>
                                <td className='p-2'>{customer.currency}</td>
                                {/* <td className='p-2'>{customer.phone}</td> */}
                                <td className='p-2'>{formatNumber(customer.debt)} {customer.currency}</td>
                                <td className='p-2'>{formatNumber(customer.credit)} {customer.currency}</td>
                                <td className='p-2'>{formatNumber(customer.balance)} {customer.currency}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3 justify-end items-center'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/customer/edit/${customer.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(customer.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                        <span className='cursor-pointer hover:scale-125 hover:text-green-600 duration-150' onClick={() => nav(`/customer/${customer.id}/payment`)}>
                                            <MdPayments />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-zinc-600 duration-150'
                                            onClick={() => {
                                                setReceiptCustomer(customer)
                                                setIsOpenReceiptModal(true)
                                            }}
                                        >
                                            <IoReceiptSharp />
                                        </span>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${customer.marked ? 'fill-red-700' : ''} w-5 h-5 cursor-pointer hover:fill-red-700 duration-150`} onClick={() => onClickToggleMark(customer.id)}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" />
                                            </svg>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={customerPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
            <CustomerReceipt
                isOpen={isOpenReceiptModal}
                closeModal={() => setIsOpenReceiptModal(false)}
                onClick={(firstDate, lastDate) => onClickDownloadReceipt(firstDate, lastDate)}
                onClickDetailed={(firstDate, lastDate) => onClickDownloadDetailedReceipt(firstDate, lastDate)}
            />
        </div >
    )
}

export default CustomerListPage